// 网站基本信息配置
export const siteInfo = {
  // 网站名称
  name: "hlly0x1",
  // 网站标语
  slogan: "Stay Simple, Stay Naive",
  // 作者名称
  author: "hlly0x1",
  // 版权年份
  copyrightYear: "2026",
  // 网站描述
  description: "Stay Simple, Stay Naive",
};

// 个人信息卡导航链接配置
export const profileNavLinks = [
  {
    label: "首页",
    href: "/",
    icon: "home",
    external: false,
  },
  {
    label: "关于我",
    href: "/blog/start",
    icon: "planet",
    external: false,
  },
  {
    label: "联系",
    href: "mailto:707155591@qq.com",
    icon: "contact",
    external: true,
  },
];

// 社交媒体链接配置
export const socialLinks = [
  {
    name: "GitHub",
    url: "https://github.com/hlly1",
    icon: "github",
    ariaLabel: "GitHub",
  },
  {
    name: "Twitter",
    url: "#",
    icon: "twitter",
    ariaLabel: "Twitter",
  },
  {
    name: "Email",
    url: "mailto:707155591@qq.com",
    icon: "email",
    ariaLabel: "Email",
  },
];

// 快速链接配置
export const quickLinks = [
  {
    label: "首页",
    path: "/",
    external: false,
  },
  {
    label: "关于我",
    path: "/blog/欢迎来到hlly0x1的个人星球",
    external: false,
  },
  {
    label: "联系",
    path: "/contact",
    external: false,
  },
];

// 获取社交链接图标SVG
export function getSocialIcon(iconName) {
  const icons = {
    github: `<path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />`,
    twitter: `<path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />`,
    email: `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />`,
  };
  return icons[iconName] || "";
}
